import { zodResolver } from '@hookform/resolvers/zod';
import { useRequestOTP } from '@medizzy/auth';
import { useNavigate, useSearchParams } from '@remix-run/react';
import { useForm } from 'react-hook-form';
import z from 'zod';
import { Button } from '~/components/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '~/components/form';
import { Input } from '~/components/input';
import { VStack } from '~/components/stack';
import { ROUTES } from '~/utils/routes';
import { SocialSignIn } from './social-sign-in';

const formSchema = z.object({ email: z.string().email() });

type FormData = z.infer<typeof formSchema>;

export function SignIn() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const form = useForm<FormData>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: searchParams.get('email') ?? '',
    },
  });
  const requestOTP = useRequestOTP({
    onSuccess: (_, vars) => {
      const params = new URLSearchParams();
      params.set('email', vars.email);
      navigate(`${ROUTES.AUTH.VERIFY}?${params.toString()}`);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  function onSubmit(data: FormData) {
    requestOTP.mutate(data);
  }

  return (
    <VStack className="gap-8">
      <SocialSignIn />
      <div className="h-[1px] w-full bg-muted-foreground/20 relative">
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="bg-card px-4 font-medium text-muted-foreground">
            or
          </span>
        </div>
      </div>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          noValidate
          className="flex flex-col gap-4"
        >
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Email address</FormLabel>
                <FormControl>
                  <Input placeholder="Email address" type="email" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <Button type="submit" size="lg" isLoading={requestOTP.isPending}>
            Continue with email
          </Button>
        </form>
      </Form>
    </VStack>
  );
}
